<!------------------------------------------------------------------------------
  Copyright (c) 2018. Keni Williams <kenneth.williams@estuk.co.uk>

  This file InfoButton.vue is part of event_pass_client.dev.
  Unauthorized copying of this file, via any medium is strictly prohibited.
  Proprietary and confidential
  InfoButton.vue can not be copied and/or distributed
  without the express permission of Keni Williams <kenneth.williams@estuk.co.uk>
  ----------------------------------------------------------------------------->

<!------------------------------------------------------------------------------
 File: InfoButton 
 Created by Keni Williams <kenneth.williams@estuk.co.uk>.
 with: IntelliJ IDEA
 Date: 2018-12-21
 Time: 14:27

 Instructions
 If using v-on:click you must use v-on:click.native instead

------------------------------------------------------------------------------->
<template>
    <component :is="component_type"
               v-on:click="click()"
               class="btn-floating-responsive btn-floating btn-floating-single waves-effect waves-light"
               :class="[
            {
            'btn-floating-small':small
            },
            cls,

            btn_type

            ]"
               v-tooltips-enabled="{
                        active:tooltip,
                        title:title
                    }"
    >
        <slot name="content"></slot>
    </component>
</template>

<script>

	import vueTooltip from '../tooltip/vueTooltip';

	Vue.use(vueTooltip);

	export default {
		name: "round-button",
		components: {},
		props: {
			cls: String | Object,
			small: {
				type: String | Boolean,
				default: false
			},
			type: String,
			link_data: String,
			btn_type: {
				type: String,
				default: 'btn-info'
			},
			title: {
				type: String
			},
			tooltip: {
				type: Boolean,
				default: true
			}
		},
		created() {
		},
		destroyed() {
		},
		mounted() {

		},
		data() {
			return {
				component_type: this.type || 'button'
			}
		},
		methods: {
		    click(){
		        this.$emit('click')
            }
        },
		watch: {},
		computed: {}
	}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// app/Shared/Resources/Assets/js/components/base/buttons/BaseButtonRound.vue